import config from '../config';

const { baseURL, version } = config;
const BASE_URL = baseURL;
const API_BASE_PATH = `${BASE_URL}/api/v1/`;
export const VERSION = version;

// ユーザー関連
export const API_GET_USER_INFO = `${API_BASE_PATH}getUserInfo`;
export const API_GET_USER_DEVICES = `${API_BASE_PATH}getUserDevices`;
export const API_GET_USER_COMPANIES = `${API_BASE_PATH}me/companies`;
export const API_UPDATE_USER_DEVICE_INFO = `${API_BASE_PATH}updateUserDeviceInfo`;

// オペレーター関連
export const API_GET_OPERATORS = `${API_BASE_PATH}operators/search`;
export const API_UPDATE_OPERATORS = `${API_BASE_PATH}updateOperators`;
export const API_CREATE_OPERATOR = `${API_BASE_PATH}operators`;
export const API_SYNC_OPERATORS = `${API_BASE_PATH}operators/sync`;

// 作業記録関連
export const API_GET_WORK_RECORD = `${API_BASE_PATH}getWorkRecord`;
export const API_GET_WORK_RECORDS = `${API_BASE_PATH}getWorkRecords`;
export const API_GET_WORK_RECORD_URLS = `${API_BASE_PATH}work-record/url/search`;
export const API_UPDATE_WORK_RECORD_STATUS = `${API_BASE_PATH}updateWorkRecordStatus`;
export const API_UPDATE_STATUS_WORK_RECORDS = `${API_BASE_PATH}work-record/status`;
export const API_UPDATE_WORK_RECORD_TAGS = `${API_BASE_PATH}work-record/tags/update`;
export const API_DELETE_WORK_RECORDS = `${API_BASE_PATH}work-record`;
export const API_DOWNLOAD_MEDIA_FILES = `${API_BASE_PATH}download`;
export const API_DOWNLOAD_CHECK_RESULT_CSV = `${API_BASE_PATH}work-record/check-result/csv/download`;

// QRコード関連
export const API_GET_QR = `${API_BASE_PATH}getQR`;
export const API_LIST_QRS = `${API_BASE_PATH}listQRs`;
export const API_UPDATE_QR = `${API_BASE_PATH}updateQR`;

// 会社関連
export const API_GET_COMPANIES = `${API_BASE_PATH}getCompanies`;
export const API_UPDATE_COMPANIES = `${API_BASE_PATH}updateCompanies`;
export const API_GET_COMPANY_ACTIVATED = `${API_BASE_PATH}company/selection`;
export const API_CREATE_COMPANY = `${API_BASE_PATH}createCompany`;

// グループ関連
export const API_GET_GROUPS = `${API_BASE_PATH}groups`;
export const API_GET_GROUP = `${API_BASE_PATH}groups/{groupId}`;
export const API_UPDATE_GROUP = `${API_BASE_PATH}groups/{groupId}`;
export const API_CREATE_GROUP = `${API_BASE_PATH}groups`;
export const API_GROUP_PUT = `${API_BASE_PATH}group/{id}`;

// デバイス関連
export const API_GET_DEVICES = `${API_BASE_PATH}getDevices`;
export const API_GET_DEVICE_DETAIL = `${API_BASE_PATH}getDeviceDetail`;
export const API_UPDATE_DEVICE = `${API_BASE_PATH}updateDevice`;

// 遠隔支援関連
export const API_CREATE_ROOM = `${API_BASE_PATH}rooms`; // room作成
export const API_GET_NO_JOINED_ROOMS = `${API_CREATE_ROOM}/me`; // room一覧取得
export const API_GET_ENTER_ROOM_INFO = `${API_CREATE_ROOM}/{appRoomId}/members/me`; // room入室情報取得
export const API_GET_ROOM_INFO = `${API_CREATE_ROOM}/{appRoomId}`; // room情報取得
export const API_RECALL_ROOM_MEMBER = `${API_CREATE_ROOM}/{appRoomId}/members/{operatorId}/call`; // roomMember再呼び出し
export const API_DELETE_ROOM = `${API_BASE_PATH}deleteRoom`;
export const API_DELETE_ROOM_BY_DEVICE = `${API_BASE_PATH}device/deleteRoom`;
export const API_GET_HISTORIES = `${API_BASE_PATH}rooms/histories`;

// 黒板関連
export const API_BLACKBOARD_BASE = `${API_BASE_PATH}blackboard-preset`;
export const API_CREATE_BLACKBOARD = `${API_BLACKBOARD_BASE}/register`;
export const API_GET_BLACKBOARD_LIST = `${API_BLACKBOARD_BASE}/search`;

// タグ関連
export const API_GET_TAGS = `${API_BASE_PATH}groups/{groupId}/tags`;
export const API_GET_COMPANY_TAGS = `${API_BASE_PATH}tags`;
export const API_UPDATE_TAGS = `${API_BASE_PATH}tags/{id}`;
export const API_DELETE_TAGS = `${API_BASE_PATH}tags/{id}`;
export const API_REIMPORT_TAGS = `${API_BASE_PATH}tags/{tagSetId}/reimport`;
export const API_IMPORT_ONE_LAYER_TAGS = `${API_BASE_PATH}tags/depths/{depth}/import`;
export const API_EXPORT_TAGS = `${API_BASE_PATH}tags/{tagSetId}/export`;
export const API_DOWNLOAD_ALL_TAGS_CSV = `${API_BASE_PATH}tags/csv/download/all`;
export const API_DOWNLOAD_TAGS_CSV = `${API_BASE_PATH}tags/csv/download`;

// 認証認可関連(デバイス認証も含む)
const CIOSV2_CLIENT_BASE_PATH = `${BASE_URL}/oauth2/ciosv2`;
export const CIOSV2_AUTHORIZE = `${CIOSV2_CLIENT_BASE_PATH}/authorize`;
export const CIOSV2_LOGOUT = `${CIOSV2_CLIENT_BASE_PATH}/logout`;
export const API_ACTIVATE = `${CIOSV2_CLIENT_BASE_PATH}/activate`;
export const API_CONFIRM_DEVICE_AUTH = `${API_BASE_PATH}device-auth`;
export const API_CHECK_DEVICE_AUTH_CODE = `${API_BASE_PATH}device-auth`;
export const API_GET_DEVICE_AUTH_SETTINGS = `${API_BASE_PATH}device-auth/settings`;
export const API_UPDATE_DEVICE_AUTH_SETTINGS = `${API_BASE_PATH}device-auth/settings`;
export const API_UPDATE_DEVICE_AUTH_SUBSCRIPTION_SETTINGS = `${API_BASE_PATH}device-auth/settings/subscriptions/{groupId}`;
export const API_REISSUE_DEVICE_AUTH_CODE = `${API_BASE_PATH}device-auth/reissue`;

// お気に入り関連
export const API_GET_FAVORITES = `${API_BASE_PATH}favorites`;
export const API_CREATE_FAVORITE = `${API_BASE_PATH}favorites`;
export const API_DELETE_FAVORITE = `${API_BASE_PATH}favorites/{id}`;
export const API_UPDATE_FAVORITE = `${API_BASE_PATH}favorites`;

// アクションログ関連
export const API_GET_ACTION_LOGS = `${API_BASE_PATH}action-logs`;
export const API_GET_DOWNLOAD_LOGS = `${API_GET_ACTION_LOGS}/downloads`;
export const API_DOWNLOAD_LOGS_CSV = `${API_GET_ACTION_LOGS}/csv`;

// 報告書関連
export const API_GET_REPORTS = `${API_GET_GROUPS}/{groupId}/reports`;
export const API_UPDATE_REPORT = `${API_GET_GROUPS}/{groupId}/reports/{reportId}`;
export const API_GET_REPORT_DETAIL = `${API_GET_GROUPS}/{groupId}/reports/{reportId}`;
export const API_GET_REPORT_PREVIEW = `${API_GET_REPORTS}/preview`;
export const API_REPORT_FRAMES = `${API_GET_GROUPS}/{groupId}/reports/{reportId}/frames`;
export const API_UPDATE_REPORT_FRAME = `${API_GET_GROUPS}/{groupId}/reports/{reportId}/frames/{frameId}`;
export const API_DELETE_REPORT_FRAME = `${API_GET_GROUPS}/{groupId}/reports/{reportId}/frames/{frameId}`;
export const API_CREATE_REPORT = `${API_GET_REPORTS}`;

// その他
export const API_DOWNLOAD = `${API_BASE_PATH}download`;
export const API_GET_GEOCODE = `${API_BASE_PATH}getGeocode`;
export const API_APP_RELEASE_NUMBER = `${API_BASE_PATH}releaseNumber`;
export const API_UPDATE_MEMBER_STATUS = `${API_BASE_PATH}updateMemberStatus`;
export const API_DOWNLOAD_ONE_AS_UNCOMPRESSED = `${API_BASE_PATH}downloadOneAsUncompressed`;
export const API_ANALYZE = `${API_BASE_PATH}analyze`;

// TODO: デバッグ用
export const API_DELETE_DEV_ROOM = `${API_BASE_PATH}deleteDevRoom`;
